<template>
  <div class="class-card">
    <h4 class="title" :class="{'gray-text': stateText === '已结营'}">{{title}}</h4>
    <div class="identity">职务：{{identitys[identityCode]}}</div>
    <div class="footer">
      <div class="date">{{begDate}}~{{endDate}}</div>
      <div class="state-card" :class="{'act-state': stateText === '进行中'}">
        <span class="state-text">{{stateText === '进行中' ? `${stateText}: ${this.day}天` : stateText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyDate } from '@/common/js/utils';

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    identityCode: {
      type: Number,
      default: 1,
      validator(val) {
        return [1, 2, 3].indexOf(val) !== -1;
      }
    },
    begDate: {
      type: String,
      required: true,
      validator(val) {
        return verifyDate(val);
      }
    },
    endDate: {
      type: String,
      required: true,
      validator(val) {
        return verifyDate(val);
      }
    },
    stateText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      identitys: {
        1: '班长',
        2: '副班长',
        3: '助教'
      },
      day: 0
    };
  },
  created() {
    if (this.stateText === '进行中') {
      // ios系统里：new Date(2021/09/11) 只支持/符号。
      const newDate = this.begDate.replace(/[.-]/g, '/');
      const begDate = new Date(newDate);
      const day = (Date.now() - begDate) / (1000 * 60 * 60 * 24);

      // day | 0 隐式转换类型，浮点数转换为整型。
      // eslint-disable-next-line no-bitwise
      this.day = day > 0 ? (day | 0) + 1 : 1;
    }
  }
};
</script>

<style lang="stylus" scoped>
defaultFont = @block {
  font-size 12px
  color #999
  line-height 12px
  font-weight 400
}

.class-card {
  box-sizing border-box
  margin-bottom 16px
  padding 16px
  width: 100%;
  background #fff
  border-radius 4px

  .title {
    font-size 16px
    color #191919
    line-height 16px
    font-weight: 500;
  }

  .identity {
    margin-top 16px
    {defaultFont}
  }
}

.footer {
  display flex
  align-items center
  margin-top 8px

  .date {
    {defaultFont}
  }

  .state-card {
    margin-left 7px
    padding 5px 10px
    border-radius: 2px;
    color #999
    background #e7e7e7

    .state-text {
      font-size 12px
      line-height 12px
      font-weight 400
      transform scale(0.8)
    }
  }

  .act-state {
    color #fff
    background #FF9645
  }
}

.gray-text {
  color #dadada
}
</style>
